import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { circleCheckmarkIcon } from '../../icons';

@Directive({ selector: '[appCircleCheckmark]' })
export class CircleCheckmarkDirective {
    span: HTMLSpanElement;

    @Input() set condition(value: boolean | undefined) {
        if (value) {
            this.renderer.appendChild(this.el.nativeElement, this.span);
        } else {
            this.renderer.removeChild(this.el.nativeElement, this.span);
        }
    }

    constructor(private el: ElementRef, private renderer: Renderer2) {
        this.span = this.renderer.createElement('span');
        this.renderer.setAttribute(this.span, 'class', 'circle-checkmark');
        this.renderer.setProperty(this.span, 'innerHTML', circleCheckmarkIcon);
    }
}
